import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    countryCode: "",
    phone: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    role: {
        id: "",
        name: "",
        category: ""
    },
    address: {
        type: 397,
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: ""
    },
    preferences: {
        unitType: "Imperial",
        dateFormat: "MM/DD/YYYY"
    },
    mrn: "",
    ssn: "",
    groups: [],
    emergencyContact: {
        fullName: "",
        relation: "",
        gender: "",
        countryCode: "",
        phone: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: ""
    },
    healthInfo: {
        criticalLevel: 0,
        phase: "",
        notes: "",
        gender: "",
        height: "",
        weight: "",
        ethnicity: "",
        conditions: "",
        dateOfBirth: ""
    },
    specialties: [],
    npi: "",
    employeeId: "",
    canHaveAppointment: false,
    canManageAvailability: false,
    updating: false,
    profilePictureURL: '',
    title: '',
    ehrAccount: false,
    ehrOrgId: 0
};

const emContact = {
    fullName: "",
    relation: "",
    gender: "",
    countryCode: "",
    phone: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: ""
}; 

const hInfo = {
    criticalLevel: 0,
    phase: "",
    notes: "",
    gender: "",
    height: "",
    weight: "",
    ethnicity: "",
    conditions: "",
    dateOfBirth: ""
};

const registrationSlice = createSlice({
    name: "registration",
    initialState,
    reducers: {
        resetRegistrationState: () => initialState,
        
        setRoleInfo: (state, action) => {
            const { name } = action.payload;
            state.role = action.payload;
            if (name === "Doctor") {
                state.canHaveAppointment = true;
            }
        },
        setFormField: (state, action) => {
            let { key, value } = action.payload;
            
            state[key] = value;
        },
        setNestedField: (state, action) => {
            const { parentKey, nestedKey, value } = action.payload;
            state[parentKey][nestedKey] = value;
        },
        setUpdatingState: (state, action) => {
            const updatingState = action.payload;
            const retState = {'id': updatingState.id};
            for (const key of Object.keys(initialState)) {
                if (key === "updating") {
                    retState[key] = true;
                } else if (Object.prototype.hasOwnProperty.call(updatingState, key)) {
                    if (key === "address") {
                        const { type, id, ...rest } = updatingState.address;
                        if (!Object.values(rest).every(val => val === "" || val == null)) {
                            retState.address = updatingState.address;
                        }
                    } else {
                        retState[key] = updatingState[key];
                    }
                } else {
                    retState[key] = initialState[key];
                }
            }
            if (updatingState.role?.name?.includes("Patient")) {
                if (!retState.emergencyContact) {
                    retState.emergencyContact = emContact;
                }
                if (!retState.healthInfo) {
                    retState.healthInfo = hInfo;
                }
            }
            Object.assign(state, retState);
        },
        setEHRAccountState: (state, action) => {
            const updatingState = action.payload;
            const retState = { ...updatingState, ehrAccount:true, ehrOrgId: updatingState.perin_org_id};
            Object.assign(state, retState);
        },
    }
});

export const {
    resetRegistrationState,
    setRoleInfo,
    setFormField,
    setNestedField,
    setUpdatingState,
    setEHRAccountState,
  } = registrationSlice.actions;
  
  export default registrationSlice.reducer;